(() => {
  const SCRIPT_ID = 'mi-europoster-real-card-preview-v5';
  if (window[SCRIPT_ID]) return;
  window[SCRIPT_ID] = true;

  const SHIRT_BASE = 'https://static.posters.cz/image/350/242804.jpg';
  const READY = 'mi-ep-real-ready';
  const PREVIEW = 'mi-ep-real-preview';

  function injectStyles() {
    if (document.getElementById(SCRIPT_ID + '-styles')) return;
    const style = document.createElement('style');
    style.id = SCRIPT_ID + '-styles';
    style.textContent = `
      .card-wrapper .card__inner { position: relative; }
      .card-wrapper .${PREVIEW} {
        position: absolute;
        inset: 0;
        z-index: 5;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        background: #fff;
        opacity: 0;
        pointer-events: none;
        transition: opacity .16s ease;
      }
      .card-wrapper.${READY} .${PREVIEW} { opacity: 1; }
      .card-wrapper.${READY} .card__media,
      .card-wrapper.${READY} .media { opacity: 0 !important; }
      .mi-ep-real-stage {
        position: relative;
        width: 100%;
        max-width: 760px;
        aspect-ratio: 1 / 1;
        flex: 0 0 auto;
        background: #fff;
      }
      .mi-ep-real-shirt,
      .mi-ep-real-design {
        position: absolute;
        display: block;
        user-select: none;
        -webkit-user-drag: none;
      }
      .mi-ep-real-shirt {
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .mi-ep-real-design {
        left: 33.5%;
        top: 28.5%;
        width: 33%;
        height: 39%;
        object-fit: contain;
        object-position: center;
        opacity: .96;
        mix-blend-mode: multiply;
      }
      @media (max-width: 749px) {
        .mi-ep-real-design { left: 33%; top: 28%; width: 34%; height: 40%; }
      }
    `;
    document.head.appendChild(style);
  }

  function isMichaelJacksonShirt(card) {
    const txt = (card.textContent || '').toLowerCase();
    return txt.includes('camiseta') && txt.includes('michael jackson');
  }

  function usableDesignUrl(card) {
    const imgs = Array.from(card.querySelectorAll('img'));
    const design = imgs.find((img) => {
      const src = img.currentSrc || img.src || '';
      const alt = (img.alt || '').toLowerCase();
      return src && !src.includes('static.posters.cz/image/350/') && (alt.includes('dise') || src.includes('cdn.shopify') || src.includes('europosters'));
    }) || imgs.find((img) => img.currentSrc || img.src);
    return design ? (design.currentSrc || design.src) : '';
  }

  function buildPreview(designUrl) {
    const wrap = document.createElement('div');
    wrap.className = PREVIEW;

    const stage = document.createElement('div');
    stage.className = 'mi-ep-real-stage';

    const shirt = document.createElement('img');
    shirt.className = 'mi-ep-real-shirt';
    shirt.alt = '';
    shirt.decoding = 'async';
    shirt.loading = 'eager';
    shirt.src = SHIRT_BASE;

    const design = document.createElement('img');
    design.className = 'mi-ep-real-design';
    design.alt = '';
    design.decoding = 'async';
    design.loading = 'eager';
    design.src = designUrl;

    stage.append(shirt, design);
    wrap.append(stage);
    return wrap;
  }

  function applyCard(card) {
    if (!card || card.dataset.miEpRealApplied === '1') return;
    if (!isMichaelJacksonShirt(card)) return;
    const inner = card.querySelector('.card__inner') || card;
    const designUrl = usableDesignUrl(card);
    if (!inner || !designUrl) return;

    card.dataset.miEpRealApplied = '1';
    card.querySelectorAll('.' + PREVIEW).forEach((el) => el.remove());
    const preview = buildPreview(designUrl);
    inner.appendChild(preview);

    const imgs = Array.from(preview.querySelectorAll('img'));
    let loaded = 0;
    const mark = () => {
      loaded += 1;
      if (loaded >= imgs.length) card.classList.add(READY);
    };
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth) mark();
      else {
        img.addEventListener('load', mark, { once: true });
        img.addEventListener('error', mark, { once: true });
      }
    });
  }

  function scan() {
    injectStyles();
    const cards = Array.from(document.querySelectorAll('.card-wrapper'));
    cards.forEach(applyCard);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
